import { render, staticRenderFns } from "./DailyBonusModal.vue?vue&type=template&id=553b6aee&scoped=true"
import script from "./DailyBonusModal.vue?vue&type=script&lang=js"
export * from "./DailyBonusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b6aee",
  null
  
)

export default component.exports